import { unidadeService } from '@/services/unidadeService';

const state = {
  unidades: []
};

const getters = {
  unidades: state => state.unidades,
};

const actions = {
  async fetchUnidades({ commit }) {
    const unidades = await unidadeService.getUnidades();
    commit('SET_UNIDADES', unidades);
  },
  async fetchUnidadesAPI({ commit }) {
    const unidades = await unidadeService.getUnidadesAPI();
    commit('SET_UNIDADES', unidades);
  },
};

const mutations = {
  SET_UNIDADES: (state, unidades) => state.unidades = unidades,
};

export default {
  state,
  getters,
  actions,
  mutations
}